import { AbstractControl } from "@angular/forms";
import { CommandService } from "~app/common/services/cqs/command.service";
import { ICommand } from "~app/common/services/cqs/model-action.service";
import { CommandControlBinderBase } from "./command-control-binder-base";
export class CommandControlBinder extends CommandControlBinderBase {

    private readonly command: ICommand;

    constructor(initParam: any, protected readonly commandService: CommandService, commandClass) {
        super(commandService);
        this.command = this.getCommand(commandClass, initParam);
    }

    /**
     * @param control FormControl to be bound. Ex: this.form.controls.exampleControl
     * @param mapExpression Either a setter function with the value from the form and the command as args, or just the name of the command property.
     */
    bindControl(control: AbstractControl, mapExpression: string | ((value, command) => void), allowEmpty = false) {
        this.initBinding(mapExpression, control.value);
        control.valueChanges.subscribe(v => {
            this.clearCommand(this.command);
            if (!control.valid) {
                return;
            }
            this.addCommand(this.command, mapExpression, v, allowEmpty);
        });
    }

    /**
     * Pushes the command manually to the transactionqueue if you for example want the init command on the queue right after the setup
     */
    manualPush() {
        this.push(this.command);
    }

    private initBinding(mapExpression, initalValue) {
        this.setValue(mapExpression, this.command, initalValue);
    }
}
